import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'

const Wrapper = styled.div`
  width: 70px;
  min-height: 70px;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  ${media.xs`
    background: none;
  `}
`

export default class YouTubeIcon extends Component {
  render() {
    return(
      <Wrapper>
        <svg
          width="32"
          height="33"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            fill="#FFF"
            fillRule="evenodd"
          >
            <path d="M23.041.177H8.782C3.94.177 0 4.123 0 8.975v14.284c0 4.852 3.94 8.798 8.782 8.798h14.26c4.842 0 8.782-3.947 8.782-8.798V8.975c0-4.852-3.94-8.798-8.783-8.798zM29 23.259c0 3.292-2.673 5.97-5.959 5.97H8.782c-3.286 0-5.958-2.678-5.958-5.97V8.975c0-3.292 2.672-5.97 5.958-5.97h14.26c3.285 0 5.958 2.678 5.958 5.97v14.284z" />
            <path d="M15.912 7.903c-4.522 0-8.2 3.685-8.2 8.214 0 4.53 3.678 8.215 8.2 8.215 4.52 0 8.2-3.685 8.2-8.215 0-4.53-3.68-8.214-8.2-8.214zm0 13.6c-2.964 0-5.377-2.416-5.377-5.386s2.412-5.386 5.377-5.386 5.377 2.417 5.377 5.386c0 2.97-2.413 5.386-5.377 5.386zM24.456 5.504a2.075 2.075 0 0 0-1.462 3.542c.383.384.918.607 1.462.607.546 0 1.078-.223 1.464-.607.386-.387.607-.923.607-1.467 0-.547-.22-1.083-.607-1.468a2.076 2.076 0 0 0-1.464-.607z" />
          </g>
        </svg>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/Footer/InstagramIcon.js